module.exports = __webpack_public_path__ + "static/img/dd-null.4b5f67f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dd-null.png
// module id = gmqy
// module chunks = 1